import { Row, Col, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';

function SeccionSituacionLaboral({
  formik,
  sitLaboralList,
  academicFormation,
  studiesList2,
  userOU,
}) {
  return (
    <Row className="mt-2">
      <Col md="2">
        <Label htmlFor="situacionLaboral">
          <small>Situación laboral</small>
        </Label>
        <Input
          id="situacionLaboral"
          name="situacionLaboral"
          type="select"
          onChange={formik.handleChange}
          value={formik.values.situacionLaboral}
          disabled={userOU.centro === 'ORIENTACIÓN'}
        >
          <option key="0-sitLaboral" value=""></option>
          {sitLaboralList.map((item, index) => (
            <option key={`${index}-sitLaboral`} value={item.Valor_cast}>
              {item.Valor_cast}
            </option>
          ))}
        </Input>
      </Col>
      <Col md="3">
        <Label htmlFor="formacionAcademica">
          <small>Curso realizado</small>
        </Label>
        <Input
          id="formacionAcademica"
          name="formacionAcademica"
          type="select"
          onChange={formik.handleChange}
          value={formik.values.formacionAcademica}
          disabled={userOU.centro === 'ORIENTACIÓN'}
        >
          {academicFormation !== ''
            ? academicFormation.map((option) => (
                <option key={`${option.id}-formacionAcademica`} value={option.Valor}>
                  {option.Valor}
                </option>
              ))
            : ''}
        </Input>
      </Col>
      <Col md="3">
        <Label htmlFor="antiguoCentro">
          <small>Centro de procedencia</small>
        </Label>
        <Input
          id="antiguoCentro"
          name="antiguoCentro"
          type="text"
          onChange={formik.handleChange}
          value={formik.values.antiguoCentro}
          disabled={userOU.centro === 'ORIENTACIÓN'}
        />
      </Col>
      <Col md="4">
        <Label htmlFor="antiguosEstudios">
          <small>Estudios de procedencia</small>
        </Label>
        <Input
          id="antiguosEstudios"
          name="antiguosEstudios"
          type="select"
          onChange={formik.handleChange}
          value={formik.values.antiguosEstudios}
          disabled={userOU.centro === 'ORIENTACIÓN'}
        >
          {studiesList2 !== ''
            ? studiesList2.map((option) => (
                <option
                  key={`${option.Id_Estudio}-estudiosProcedencia`}
                  value={option.Estudio}
                >
                  {option.Estudio_cast}
                </option>
              ))
            : ''}
        </Input>
      </Col>
    </Row>
  );
}

SeccionSituacionLaboral.propTypes = {
  formik: PropTypes.object.isRequired,
  sitLaboralList: PropTypes.array.isRequired,
  academicFormation: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  studiesList2: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  userOU: PropTypes.object.isRequired,
};

export default SeccionSituacionLaboral;
